/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Exec_CheckpointInputs */

const en_inbox_exec_checkpoint = /** @type {(inputs: Inbox_Exec_CheckpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask before each stage`)
};

const id_inbox_exec_checkpoint = /** @type {(inputs: Inbox_Exec_CheckpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanya dulu tiap tahap`)
};

/**
* | output |
* | --- |
* | "Ask before each stage" |
*
* @param {Inbox_Exec_CheckpointInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_exec_checkpoint = /** @type {((inputs?: Inbox_Exec_CheckpointInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Exec_CheckpointInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_exec_checkpoint(inputs)
	return en_inbox_exec_checkpoint(inputs)
});